import React from 'react';

export default function LanguageSection({ disabled, settings, options, onChange }) {
  const defaultLanguage = settings?.defaultLanguage || 'en';
  const unavailableDefault = options.length > 0 && !options.some(option => option.code === defaultLanguage);

  return (
    <section className="customize-ai-section language-section">
      <h2>Conversation language</h2>
      <p>The receptionist starts in your default language and follows the caller’s language whenever it clearly changes during the call.</p>
      <div className="receptionist-language-default">
        <label htmlFor="receptionist-default-language">Default language</label>
        <select id="receptionist-default-language" disabled={disabled || !options.length}
          value={defaultLanguage}
          onChange={event => onChange({ defaultLanguage: event.target.value })}>
          {unavailableDefault && <option value={defaultLanguage} disabled>Previously selected language ({defaultLanguage}): choose a supported language</option>}
          {options.map(option => <option key={option.code} value={option.code}>{option.name}</option>)}
        </select>
      </div>
      <small className="receptionist-language-note">Preview with Play greeting. Publish to apply changes to calls. Your original greeting text stays editable.</small>
    </section>
  );
}
